/**
 * Created by Vernost.yang on 2/6/2017.
 */
import { Component, OnInit, Input } from "@angular/core";
import { Router } from "@angular/router";
import { Login } from "../../models/login";
import { VernostServiceService } from "../../services/vernost-service.service";

@Component({
  selector: "navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.css"]
})
export class Navigation implements OnInit {
  emailPattern =
    "^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$";
  passwordPattern = "^[a-zA-z0-9]{6,}$";
  screen_details: any = [];
  user1: any = {};
  parent_table = "mst_user";
  parent_table_Id = "USER_ID";
  USER_CODE = "USER_CODE";
  USER_FIRSTNAME = "USER_FIRSTNAME";
  USER_LASTNAME = "USER_LASTNAME";
  USER_EMAIL = "USER_EMAIL";
  USER_PASSWORD = "USER_PASSWORD";
  USER_ADDRESS = "USER_ADDRESS";
  USER_MOBILE = "USER_MOBILE";
  ROLE_ID = "ROLE_ID";
  returnUrl: string;
  errorUrl: string;
  functionality_data: any = [];
  uid: string;
  userinfo: any;
  role_name: string;
  fname = "";
  lname = "";
  ucode = "";
  dbFields = [this.USER_EMAIL, this.USER_PASSWORD];
  formData: any = [];
  finalFun: any = [];

  @Input() loginInfo: Login;

  constructor(
    private router: Router,
    private vernostService: VernostServiceService
  ) {}

  ngOnInit() {
    //console.log("this.router--->", this.router.url);
   
    this.uid = localStorage.getItem("uid");
    this.fname = localStorage.getItem("fname");
    this.lname = localStorage.getItem("lname");
    this.ucode = localStorage.getItem("ucode");
    if (this.fname == "" || this.fname == undefined) {
      this.router.navigate(["/login"]);
    }
    var array = {
      // parent_table: this.parent_table,
      // dbFields: this.dbFields,
      // parent_table_ID: this.parent_table_Id,
      uid: this.uid
    };

    // //console.log("uid=======" + this.uid);

    // console.log("array==============", array);

    this.vernostService.loginSession(array).subscribe(response => {
     // alert("response NAviation======" + JSON.stringify(response));
       //  console.log("rrrrrrrrrrrrrrrrrrrrrrrr",response);
      this.functionality_data = response[0].result[0];
      var parentfun;
      parentfun = [];
      console.log("BBBBBBBBBBBBBBBBB",response[0]["is_tbo_on"]);
      localStorage.setItem("is_tbo_on", response[0]["is_tbo_on"]);
      localStorage.setItem("travelPortEMTRequired", response[0]["travelPortEMTRequired"]);
      this.functionality_data.forEach(element => {
        // //console.log("element", element);
        if (
          element.FUN_ROUTER_NAME == null ||
          element.FUN_ROUTER_NAME == "" ||
          element.FUN_PARENT == "" ||
          element.FUN_PARENT == null
        ) {
          parentfun.push(element);
        }
      });
      // //console.log("Parent", parentfun)
      // alert("response NAviation======" + JSON.stringify(this.functionality_data));
      parentfun.forEach(parelement => {
        var child = [];
        this.functionality_data.forEach(chelement => {
          //console.log("parelement.FUN_ID", parelement.FUN_ID);
          //console.log("chelement.FUN_PARENT", chelement.FUN_PARENT);
          if (parelement.FUN_ID == chelement.FUN_PARENT) {
            child.push(chelement);
          }
        });
        this.finalFun.push({
          parent_name: parelement.FUN_NAME,
          child: child,
          route: parelement.FUN_ROUTER_NAME,
          ref_name: parelement.FUN_NAME.toString()
            .split(" ")
            .join("")
        });
      });
      console.log(this.finalFun,"gggggggggggggggggggggggggggg")
      
      // //console.log("child",child);
      //console.log("Final", this.finalFun);
      // //console.log(" this.functionality_data===========", response[0].result[0]);
      ////console.log("role name"+response[0].result[0][0].ROLE_NAME);
      this.role_name = response[0].result[0][0].ROLE_NAME;
    });
  }
  activeRoute(routename: string): boolean {
    return this.router.url.indexOf(routename) > -1;
  }

  dropdown() {
    //console.log("call drop down");
    var x = document.getElementById("mydiv");
    x.classList.toggle("mydiv");

    //console.log("call drop XXXXXX" + x);

    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
  }

  selectFunction(fid) {
    // alert("bjbj"+fid);
    localStorage.setItem("fid", fid);
  }
}
